import * as React from 'react';
import { Stack } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { Skeleton } from '../Skeleton/Skeleton';

interface ILeftLayerShimmerProps {
    variant: 'job' | 'activity';
}

export const LeftLayerShimmer: React.FC<ILeftLayerShimmerProps> = ({ variant }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Stack
            sx={{
                width: '100%',
                borderRadius: 2,
                overflow: 'visible',
                my: 2,
                backgroundColor: theme[themeStyle].secondaryBg,
                height: '300px',
            }}>
            <Stack direction="column" justifyContent="space-between" height={'100%'} width={'100%'}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" p={2}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Stack direction="row" alignItems="center" gap={2}>
                            <Skeleton variant="circular" height={50} width={50} />
                            <Stack>
                                <Stack direction="row" gap={'3px'}>
                                    <Skeleton animation="wave" width={'50px'} height={'10px'} />
                                </Stack>
                                <Stack alignItems="flex-start">
                                    <Skeleton animation="wave" width={'20px'} height={'10px'} />
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>

                    <Skeleton animation="pulse" width={'15px'} height={'25px'} />
                </Stack>
                {variant === 'activity' ? (
                    <Stack direction={'row'} alignSelf="flex-end" justifyContent="space-between" p={2} width={'100%'}>
                        <Skeleton animation="wave" width={'60px'} height={'20px'} />
                        <Skeleton animation="wave" width={'60px'} height={'20px'} />
                        <Skeleton animation="wave" width={'60px'} height={'20px'} />
                    </Stack>
                ) : (
                    <Stack
                        direction={{
                            xs: 'column',
                            sm: 'row',
                        }}
                        alignSelf="flex-end"
                        justifyContent="space-between"
                        p={2}
                        gap={2}
                        width={'100%'}>
                        <Skeleton
                            animation="wave"
                            sx={{
                                flex: 0.5,
                                borderRadius: 15,
                            }}
                            height={'60px'}
                        />
                        <Skeleton
                            animation="wave"
                            sx={{
                                flex: 0.5,
                                borderRadius: 15,
                            }}
                            height={'60px'}
                        />
                    </Stack>
                )}
            </Stack>
        </Stack>
    );
};
